module.exports = __webpack_public_path__ + "media/images/flags/32/Gibraltar-9650f4604df8ab8c57d4d33c87360eb3.png";